import { render, staticRenderFns } from "./PromotionsReportExcel.vue?vue&type=template&id=375d9115&scoped=true"
import script from "./PromotionsReportExcel.vue?vue&type=script&lang=js"
export * from "./PromotionsReportExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375d9115",
  null
  
)

export default component.exports